import React, { useState } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { TopBar } from "./TopBar";
import { SideNav } from "./SideNav";
import { Main, DrawerHeader } from "./styles";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(!isMobile);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100vh",
        flex: 1,
      }}
    >
      <TopBar onDrawerToggle={handleDrawerToggle} />
      <SideNav open={open} onDrawerClose={handleDrawerToggle} />
      <Main id="main-mainlayout" open={open}>
        <DrawerHeader />
        <span
          id="main-content-container"
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            overflow: "auto",
            minHeight: 0,
            maxHeight: `calc(100% - ${theme.mixins.toolbar.maxHeight}px)`,
          }}
        >
          {children}
        </span>
      </Main>
    </Box>
  );
};
